import React, { FC } from 'react';

import Loadable from 'Jsx/Shared/Loadable';

import { CardLeadPhoneProp } from './CardLeadPhone';

const LazyCardLead: FC<CardLeadPhoneProp> = props => (
  <Loadable
    Loader={<div className="h-full w-full bg-gray-light"> </div>}
    module={() =>
      import(
        /* webpackChunkName: "card-lead-phone" */
        './CardLeadPhone'
      )
    }
    {...props}
  />
);

export default LazyCardLead;
